// ============================================================
// useIsMobile.js / useIsTablet.js
// Custom React hooks for responsive breakpoints.
//
// useIsMobile()  — returns true when window < 640px (phone)
// useIsTablet()  — returns true when window < 1024px (tablet)
//
// Usage:
//   const isMobile = useIsMobile();
//   const isTablet = useIsTablet();
// ============================================================

import { useState, useEffect } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return isMobile;
};

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handler = () => setIsTablet(window.innerWidth < 1024);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return isTablet;
};
